export { default as JournalSearch } from './JournalSearch'
export * from '../Search/SearchBar'
export * from './SearchHits'
